import io from 'socket.io-client'
let socket
const SOCKET_URL = process.env.REACT_APP_SOCKET_URL

export const initiateSocket = () => {
    // Skip socket connection in development if no socket server is running
    if (!SOCKET_URL || SOCKET_URL.includes('localhost')) {
        console.warn('Socket server not available in development mode');
        return null;
    }
    
    try {
        socket = io(SOCKET_URL, {
            forceNew: true,
            timeout: 5000
        })
        return socket;
    } catch (error) {
        console.error('Failed to initialize socket:', error);
        return null;
    }
}

export const subscribeOpenOrders = (callback) => {
    if (!socket) return
    socket.on('open-orders', (data) => {
        callback(null, data)
    })
}

export const subscribeFinishedOrders = (callback) => {
    if (!socket) return
    socket.on('finished-orders', (data) => {
        callback(null, data)
    })
}